//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAgeCategoryClient {
    /**
     * @return Success
     */
    getAgeCategories( cancelToken?: CancelToken): Promise<AgeCategory[]>;
}

export class AgeCategoryClient implements IAgeCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getAgeCategories( cancelToken?: CancelToken): Promise<AgeCategory[]> {
        let url_ = this.baseUrl + "/api/AgeCategory/GetAgeCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgeCategories(_response);
        });
    }

    protected processGetAgeCategories(response: AxiosResponse): Promise<AgeCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgeCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<AgeCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgeCategory[]>(null as any);
    }
}

export interface IAuthClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    register(body?: RegisterModel | undefined,  cancelToken?: CancelToken): Promise<string>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body?: LoginModel | undefined,  cancelToken?: CancelToken): Promise<UserDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body?: ForgotPasswordModel | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class AuthClient implements IAuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body?: RegisterModel | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body?: LoginModel | undefined, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body?: ForgotPasswordModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBracketClient {
    /**
     * @param tournamentId (optional) 
     * @return Success
     */
    getBrackets(tournamentId?: number | undefined,  cancelToken?: CancelToken): Promise<TournamentBracket[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getBracket(id?: number | undefined,  cancelToken?: CancelToken): Promise<BracketDetailsModel>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getBracketWinner(id?: number | undefined,  cancelToken?: CancelToken): Promise<WinnerModel>;
    /**
     * @param bracketId (optional) 
     * @return Success
     */
    canCreateRepechage(bracketId?: number | undefined, side?: RepechageSide | undefined,  cancelToken?: CancelToken): Promise<boolean>;
    /**
     * @param bracketId (optional) 
     * @param side (optional) 
     * @return Success
     */
    previewRepechage(bracketId?: number | undefined, side?: RepechageSide | undefined,  cancelToken?: CancelToken): Promise<BracketPreviewModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createRepechage(body?: CreateRepechageRequest | undefined,  cancelToken?: CancelToken): Promise<TournamentBracket>;
    /**
     * @param mainBracketId (optional) 
     * @return Success
     */
    getRepechageBracket(mainBracketId?: number | undefined, side?: RepechageSide | undefined,  cancelToken?: CancelToken): Promise<TournamentBracket>;
    /**
     * @param mainBracketId (optional) 
     * @return Success
     */
    getRepechageBrackets(mainBracketId?: number | undefined,  cancelToken?: CancelToken): Promise<RepechageBracketsModel>;
}

export class BracketClient implements IBracketClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param tournamentId (optional) 
     * @return Success
     */
    getBrackets(tournamentId?: number | undefined, cancelToken?: CancelToken): Promise<TournamentBracket[]> {
        let url_ = this.baseUrl + "/api/Bracket/GetBrackets?";
        if (tournamentId === null)
            throw new globalThis.Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrackets(_response);
        });
    }

    protected processGetBrackets(response: AxiosResponse): Promise<TournamentBracket[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TournamentBracket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TournamentBracket[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TournamentBracket[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBracket(id?: number | undefined, cancelToken?: CancelToken): Promise<BracketDetailsModel> {
        let url_ = this.baseUrl + "/api/Bracket/GetBracket?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBracket(_response);
        });
    }

    protected processGetBracket(response: AxiosResponse): Promise<BracketDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BracketDetailsModel.fromJS(resultData200);
            return Promise.resolve<BracketDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BracketDetailsModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBracketWinner(id?: number | undefined, cancelToken?: CancelToken): Promise<WinnerModel> {
        let url_ = this.baseUrl + "/api/Bracket/GetBracketWinner?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBracketWinner(_response);
        });
    }

    protected processGetBracketWinner(response: AxiosResponse): Promise<WinnerModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WinnerModel.fromJS(resultData200);
            return Promise.resolve<WinnerModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WinnerModel>(null as any);
    }

    /**
     * @param bracketId (optional) 
     * @return Success
     */
    canCreateRepechage(bracketId?: number | undefined, side?: RepechageSide | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Bracket/CanCreateRepechage?";
        if (bracketId === null)
            throw new globalThis.Error("The parameter 'bracketId' cannot be null.");
        else if (bracketId !== undefined)
            url_ += "bracketId=" + encodeURIComponent("" + bracketId) + "&";
        if (side === null)
            throw new globalThis.Error("The parameter 'side' cannot be null.");
        else if (side !== undefined)
            url_ += "side=" + encodeURIComponent("" + side) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCanCreateRepechage(_response);
        });
    }

    protected processCanCreateRepechage(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param bracketId (optional) 
     * @return Success
     */
    previewRepechage(bracketId?: number | undefined, side?: RepechageSide | undefined, cancelToken?: CancelToken): Promise<BracketPreviewModel> {
        let url_ = this.baseUrl + "/api/Bracket/PreviewRepechage?";
        if (bracketId === null)
            throw new globalThis.Error("The parameter 'bracketId' cannot be null.");
        else if (bracketId !== undefined)
            url_ += "bracketId=" + encodeURIComponent("" + bracketId) + "&";
        if (side === null)
            throw new globalThis.Error("The parameter 'side' cannot be null.");
        else if (side !== undefined)
            url_ += "side=" + encodeURIComponent("" + side) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewRepechage(_response);
        });
    }

    protected processPreviewRepechage(response: AxiosResponse): Promise<BracketPreviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BracketPreviewModel.fromJS(resultData200);
            return Promise.resolve<BracketPreviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BracketPreviewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRepechage(body?: CreateRepechageRequest | undefined, cancelToken?: CancelToken): Promise<TournamentBracket> {
        let url_ = this.baseUrl + "/api/Bracket/CreateRepechage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRepechage(_response);
        });
    }

    protected processCreateRepechage(response: AxiosResponse): Promise<TournamentBracket> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TournamentBracket.fromJS(resultData200);
            return Promise.resolve<TournamentBracket>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TournamentBracket>(null as any);
    }

    /**
     * @param mainBracketId (optional) 
     * @return Success
     */
    getRepechageBracket(mainBracketId?: number | undefined, side?: RepechageSide | undefined, cancelToken?: CancelToken): Promise<TournamentBracket> {
        let url_ = this.baseUrl + "/api/Bracket/GetRepechageBracket?";
        if (mainBracketId === null)
            throw new globalThis.Error("The parameter 'mainBracketId' cannot be null.");
        else if (mainBracketId !== undefined)
            url_ += "mainBracketId=" + encodeURIComponent("" + mainBracketId) + "&";
        if (side === null)
            throw new globalThis.Error("The parameter 'side' cannot be null.");
        else if (side !== undefined)
            url_ += "side=" + encodeURIComponent("" + side) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRepechageBracket(_response);
        });
    }

    protected processGetRepechageBracket(response: AxiosResponse): Promise<TournamentBracket> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TournamentBracket.fromJS(resultData200);
            return Promise.resolve<TournamentBracket>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TournamentBracket>(null as any);
    }

    getRepechageBrackets(mainBracketId?: number | undefined, cancelToken?: CancelToken): Promise<RepechageBracketsModel> {
        let url_ = this.baseUrl + "/api/Bracket/GetRepechageBrackets?";
        if (mainBracketId === null)
            throw new globalThis.Error("The parameter 'mainBracketId' cannot be null.");
        else if (mainBracketId !== undefined)
            url_ += "mainBracketId=" + encodeURIComponent("" + mainBracketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRepechageBrackets(_response);
        });
    }

    protected processGetRepechageBrackets(response: AxiosResponse): Promise<RepechageBracketsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RepechageBracketsModel.fromJS(resultData200);
            return Promise.resolve<RepechageBracketsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RepechageBracketsModel>(null as any);
    }
}

export interface IConfigClient {
    /**
     * @return Success
     */
    getConfig( cancelToken?: CancelToken): Promise<ConfigModel>;
}

export class ConfigClient implements IConfigClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getConfig( cancelToken?: CancelToken): Promise<ConfigModel> {
        let url_ = this.baseUrl + "/api/Config/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConfig(_response);
        });
    }

    protected processGetConfig(response: AxiosResponse): Promise<ConfigModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigModel.fromJS(resultData200);
            return Promise.resolve<ConfigModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigModel>(null as any);
    }
}

export interface IMatchClient {
    /**
     * @param bracketId (optional) 
     * @return Success
     */
    getMatches(bracketId?: number | undefined,  cancelToken?: CancelToken): Promise<Match[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getMatch(id?: number | undefined,  cancelToken?: CancelToken): Promise<Match>;
    /**
     * @param id (optional) 
     * @return Success
     */
    startMatch(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    pauseMatch(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    resumeMatch(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    addScore(id?: number | undefined, body?: ScoreModel | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    endMatch(id?: number | undefined, body?: EndMatchModel | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitFinalResult(id?: number | undefined, body?: MatchFinalResultModel | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class MatchClient implements IMatchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param bracketId (optional) 
     * @return Success
     */
    getMatches(bracketId?: number | undefined, cancelToken?: CancelToken): Promise<Match[]> {
        let url_ = this.baseUrl + "/api/Match/GetMatches?";
        if (bracketId === null)
            throw new globalThis.Error("The parameter 'bracketId' cannot be null.");
        else if (bracketId !== undefined)
            url_ += "bracketId=" + encodeURIComponent("" + bracketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMatches(_response);
        });
    }

    protected processGetMatches(response: AxiosResponse): Promise<Match[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Match.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Match[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Match[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMatch(id?: number | undefined, cancelToken?: CancelToken): Promise<Match> {
        let url_ = this.baseUrl + "/api/Match/GetMatch?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMatch(_response);
        });
    }

    protected processGetMatch(response: AxiosResponse): Promise<Match> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Match.fromJS(resultData200);
            return Promise.resolve<Match>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Match>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    startMatch(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/StartMatch?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartMatch(_response);
        });
    }

    protected processStartMatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pauseMatch(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/PauseMatch?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPauseMatch(_response);
        });
    }

    protected processPauseMatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    resumeMatch(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/ResumeMatch?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResumeMatch(_response);
        });
    }

    protected processResumeMatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    addScore(id?: number | undefined, body?: ScoreModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/AddScore?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddScore(_response);
        });
    }

    protected processAddScore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    endMatch(id?: number | undefined, body?: EndMatchModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/EndMatch?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEndMatch(_response);
        });
    }

    protected processEndMatch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    submitFinalResult(id?: number | undefined, body?: MatchFinalResultModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Match/SubmitFinalResult?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitFinalResult(_response);
        });
    }

    protected processSubmitFinalResult(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface INewsClient {
    /**
     * @return Success
     */
    getNews( cancelToken?: CancelToken): Promise<NewsModel>;
}

export class NewsClient implements INewsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getNews( cancelToken?: CancelToken): Promise<NewsModel> {
        let url_ = this.baseUrl + "/api/news/GetNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNews(_response);
        });
    }

    protected processGetNews(response: AxiosResponse): Promise<NewsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsModel.fromJS(resultData200);
            return Promise.resolve<NewsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsModel>(null as any);
    }
}

export interface IParticipantClient {
    /**
     * @param tournamentId (optional) 
     * @return Success
     */
    getParticipants(tournamentId?: number | undefined,  cancelToken?: CancelToken): Promise<Participant[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getParticipant(id?: number | undefined,  cancelToken?: CancelToken): Promise<Participant>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createParticipant(body?: ParticipantDto | undefined,  cancelToken?: CancelToken): Promise<Participant>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateParticipant(body?: ParticipantDto | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    deleteParticipant(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class ParticipantClient implements IParticipantClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param tournamentId (optional) 
     * @return Success
     */
    getParticipants(tournamentId?: number | undefined, cancelToken?: CancelToken): Promise<Participant[]> {
        let url_ = this.baseUrl + "/api/Participant/GetParticipants?";
        if (tournamentId === null)
            throw new globalThis.Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: AxiosResponse): Promise<Participant[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Participant.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Participant[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Participant[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getParticipant(id?: number | undefined, cancelToken?: CancelToken): Promise<Participant> {
        let url_ = this.baseUrl + "/api/Participant/GetParticipant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetParticipant(_response);
        });
    }

    protected processGetParticipant(response: AxiosResponse): Promise<Participant> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Participant.fromJS(resultData200);
            return Promise.resolve<Participant>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Participant>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createParticipant(body?: ParticipantDto | undefined, cancelToken?: CancelToken): Promise<Participant> {
        let url_ = this.baseUrl + "/api/Participant/CreateParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateParticipant(_response);
        });
    }

    protected processCreateParticipant(response: AxiosResponse): Promise<Participant> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Participant.fromJS(resultData201);
            return Promise.resolve<Participant>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Participant>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateParticipant(body?: ParticipantDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Participant/UpdateParticipant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateParticipant(_response);
        });
    }

    protected processUpdateParticipant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteParticipant(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Participant/DeleteParticipant?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteParticipant(_response);
        });
    }

    protected processDeleteParticipant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPersonClient {
    /**
     * @return Success
     */
    getPersons( cancelToken?: CancelToken): Promise<Person[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getPerson(id?: number | undefined,  cancelToken?: CancelToken): Promise<Person>;
    /**
     * @param body (optional) 
     * @return Success
     */
    createPerson(body?: PersonCreateModel | undefined,  cancelToken?: CancelToken): Promise<Person>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePerson(id?: number | undefined, body?: PersonCreateModel | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    deletePerson(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class PersonClient implements IPersonClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getPersons( cancelToken?: CancelToken): Promise<Person[]> {
        let url_ = this.baseUrl + "/api/Person/GetPersons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPersons(_response);
        });
    }

    protected processGetPersons(response: AxiosResponse): Promise<Person[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Person.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Person[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPerson(id?: number | undefined, cancelToken?: CancelToken): Promise<Person> {
        let url_ = this.baseUrl + "/api/Person/GetPerson?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPerson(_response);
        });
    }

    protected processGetPerson(response: AxiosResponse): Promise<Person> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Person.fromJS(resultData200);
            return Promise.resolve<Person>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPerson(body?: PersonCreateModel | undefined, cancelToken?: CancelToken): Promise<Person> {
        let url_ = this.baseUrl + "/api/Person/CreatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePerson(_response);
        });
    }

    protected processCreatePerson(response: AxiosResponse): Promise<Person> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Person.fromJS(resultData200);
            return Promise.resolve<Person>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Person>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePerson(id?: number | undefined, body?: PersonCreateModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Person/UpdatePerson?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePerson(_response);
        });
    }

    protected processUpdatePerson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePerson(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Person/DeletePerson?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePerson(_response);
        });
    }

    protected processDeletePerson(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRoleClient {
    /**
     * @return Success
     */
    getRoles( cancelToken?: CancelToken): Promise<Role[]>;
}

export class RoleClient implements IRoleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getRoles( cancelToken?: CancelToken): Promise<Role[]> {
        let url_ = this.baseUrl + "/api/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<Role[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Role[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Role[]>(null as any);
    }
}

export interface ITournamentClient {
    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getTournaments(page?: number | undefined, pageSize?: number | undefined,  cancelToken?: CancelToken): Promise<Tournament[]>;
    /**
     * @param id (optional) 
     * @return Success
     */
    getTournament(id?: number | undefined,  cancelToken?: CancelToken): Promise<Tournament>;
    /**
     * @param body (optional) 
     * @return Created
     */
    createTournament(body?: TournamentCreateModel | undefined,  cancelToken?: CancelToken): Promise<Tournament>;
    /**
     * @param id (optional) 
     * @return Success
     */
    startTournament(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param tournamentId (optional) 
     * @param weightCategoryInTournamentId (optional) 
     * @param ageCategoryInTournamentId (optional) 
     * @param isFormatOverridden (optional) 
     * @param manualFormat (optional) 
     * @return Success
     */
    getCategoryDraw(tournamentId?: number | undefined, weightCategoryInTournamentId?: number | undefined, ageCategoryInTournamentId?: number | undefined, isFormatOverridden?: boolean | undefined, manualFormat?: CompetitionFormat | undefined,  cancelToken?: CancelToken): Promise<CategoryDrawModel>;
    /**
     * @param tournamentId (optional) 
     * @param weightCategoryInTournamentId (optional) 
     * @param ageCategoryInTournamentId (optional) 
     * @param isFormatOverridden (optional) 
     * @param manualFormat (optional) 
     * @return Success
     */
    previewBracket(tournamentId?: number | undefined, weightCategoryInTournamentId?: number | undefined, ageCategoryInTournamentId?: number | undefined, isFormatOverridden?: boolean | undefined, manualFormat?: CompetitionFormat | undefined,  cancelToken?: CancelToken): Promise<BracketPreviewModel>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTournament(id?: number | undefined, body?: TournamentCreateModel | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTournamentOfficials(id?: number | undefined, body?: TournamentOfficialsModel | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTournament(id?: number | undefined,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveBracket(body?: ApproveBracketRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class TournamentClient implements ITournamentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getTournaments(page?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<Tournament[]> {
        let url_ = this.baseUrl + "/api/Tournament/GetTournaments?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTournaments(_response);
        });
    }

    protected processGetTournaments(response: AxiosResponse): Promise<Tournament[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Tournament.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Tournament[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Tournament[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTournament(id?: number | undefined, cancelToken?: CancelToken): Promise<Tournament> {
        let url_ = this.baseUrl + "/api/Tournament/GetTournament?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTournament(_response);
        });
    }

    protected processGetTournament(response: AxiosResponse): Promise<Tournament> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Tournament.fromJS(resultData200);
            return Promise.resolve<Tournament>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Tournament>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createTournament(body?: TournamentCreateModel | undefined, cancelToken?: CancelToken): Promise<Tournament> {
        let url_ = this.baseUrl + "/api/Tournament/CreateTournament";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTournament(_response);
        });
    }

    protected processCreateTournament(response: AxiosResponse): Promise<Tournament> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = Tournament.fromJS(resultData201);
            return Promise.resolve<Tournament>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Tournament>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    startTournament(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tournament/StartTournament?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartTournament(_response);
        });
    }

    protected processStartTournament(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tournamentId (optional) 
     * @param weightCategoryInTournamentId (optional) 
     * @param ageCategoryInTournamentId (optional) 
     * @param isFormatOverridden (optional) 
     * @param manualFormat (optional) 
     * @return Success
     */
    getCategoryDraw(tournamentId?: number | undefined, weightCategoryInTournamentId?: number | undefined, ageCategoryInTournamentId?: number | undefined, isFormatOverridden?: boolean | undefined, manualFormat?: CompetitionFormat | undefined, cancelToken?: CancelToken): Promise<CategoryDrawModel> {
        let url_ = this.baseUrl + "/api/Tournament/GetCategoryDraw?";
        if (tournamentId === null)
            throw new globalThis.Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&";
        if (weightCategoryInTournamentId === null)
            throw new globalThis.Error("The parameter 'weightCategoryInTournamentId' cannot be null.");
        else if (weightCategoryInTournamentId !== undefined)
            url_ += "weightCategoryInTournamentId=" + encodeURIComponent("" + weightCategoryInTournamentId) + "&";
        if (ageCategoryInTournamentId === null)
            throw new globalThis.Error("The parameter 'ageCategoryInTournamentId' cannot be null.");
        else if (ageCategoryInTournamentId !== undefined)
            url_ += "ageCategoryInTournamentId=" + encodeURIComponent("" + ageCategoryInTournamentId) + "&";
        if (isFormatOverridden === null)
            throw new globalThis.Error("The parameter 'isFormatOverridden' cannot be null.");
        else if (isFormatOverridden !== undefined)
            url_ += "isFormatOverridden=" + encodeURIComponent("" + isFormatOverridden) + "&";
        if (manualFormat === null)
            throw new globalThis.Error("The parameter 'manualFormat' cannot be null.");
        else if (manualFormat !== undefined)
            url_ += "manualFormat=" + encodeURIComponent("" + manualFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategoryDraw(_response);
        });
    }

    protected processGetCategoryDraw(response: AxiosResponse): Promise<CategoryDrawModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CategoryDrawModel.fromJS(resultData200);
            return Promise.resolve<CategoryDrawModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CategoryDrawModel>(null as any);
    }

    /**
     * @param tournamentId (optional) 
     * @param weightCategoryInTournamentId (optional) 
     * @param ageCategoryInTournamentId (optional) 
     * @param isFormatOverridden (optional) 
     * @param manualFormat (optional) 
     * @return Success
     */
    previewBracket(tournamentId?: number | undefined, weightCategoryInTournamentId?: number | undefined, ageCategoryInTournamentId?: number | undefined, isFormatOverridden?: boolean | undefined, manualFormat?: CompetitionFormat | undefined, cancelToken?: CancelToken): Promise<BracketPreviewModel> {
        let url_ = this.baseUrl + "/api/Tournament/PreviewBracket?";
        if (tournamentId === null)
            throw new globalThis.Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&";
        if (weightCategoryInTournamentId === null)
            throw new globalThis.Error("The parameter 'weightCategoryInTournamentId' cannot be null.");
        else if (weightCategoryInTournamentId !== undefined)
            url_ += "weightCategoryInTournamentId=" + encodeURIComponent("" + weightCategoryInTournamentId) + "&";
        if (ageCategoryInTournamentId === null)
            throw new globalThis.Error("The parameter 'ageCategoryInTournamentId' cannot be null.");
        else if (ageCategoryInTournamentId !== undefined)
            url_ += "ageCategoryInTournamentId=" + encodeURIComponent("" + ageCategoryInTournamentId) + "&";
        if (isFormatOverridden === null)
            throw new globalThis.Error("The parameter 'isFormatOverridden' cannot be null.");
        else if (isFormatOverridden !== undefined)
            url_ += "isFormatOverridden=" + encodeURIComponent("" + isFormatOverridden) + "&";
        if (manualFormat === null)
            throw new globalThis.Error("The parameter 'manualFormat' cannot be null.");
        else if (manualFormat !== undefined)
            url_ += "manualFormat=" + encodeURIComponent("" + manualFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewBracket(_response);
        });
    }

    protected processPreviewBracket(response: AxiosResponse): Promise<BracketPreviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BracketPreviewModel.fromJS(resultData200);
            return Promise.resolve<BracketPreviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BracketPreviewModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTournament(id?: number | undefined, body?: TournamentCreateModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tournament/UpdateTournament?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTournament(_response);
        });
    }

    protected processUpdateTournament(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateTournamentOfficials(id?: number | undefined, body?: TournamentOfficialsModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tournament/UpdateTournamentOfficials?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTournamentOfficials(_response);
        });
    }

    protected processUpdateTournamentOfficials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 204) {
            return Promise.resolve<void>(null as any);
        }
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTournament(id?: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tournament/DeleteTournament?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTournament(_response);
        });
    }

    protected processDeleteTournament(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveBracket(body?: ApproveBracketRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tournament/ApproveBracket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveBracket(_response);
        });
    }

    protected processApproveBracket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IWeatherForecastClient {
    /**
     * @return Success
     */
    weatherForecast( cancelToken?: CancelToken): Promise<WeatherForecast[]>;
}

export class WeatherForecastClient implements IWeatherForecastClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    weatherForecast( cancelToken?: CancelToken): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/WeatherForecast";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWeatherForecast(_response);
        });
    }

    protected processWeatherForecast(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WeatherForecast[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export interface IWeightCategoryClient {
    /**
     * @return Success
     */
    getWeightCategories( cancelToken?: CancelToken): Promise<WeightCategory[]>;
}

export class WeightCategoryClient implements IWeightCategoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getWeightCategories( cancelToken?: CancelToken): Promise<WeightCategory[]> {
        let url_ = this.baseUrl + "/api/WeightCategory/GetWeightCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeightCategories(_response);
        });
    }

    protected processGetWeightCategories(response: AxiosResponse): Promise<WeightCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeightCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<WeightCategory[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeightCategory[]>(null as any);
    }
}

export class AgeCategory implements IAgeCategory {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    minAge!: number;
    maxAge!: number;
    name!: string;
    tournaments?: AgeCategoryInTournament[] | undefined;

    constructor(data?: IAgeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.minAge = _data["minAge"];
            this.maxAge = _data["maxAge"];
            this.name = _data["name"];
            if (Array.isArray(_data["tournaments"])) {
                this.tournaments = [] as any;
                for (let item of _data["tournaments"])
                    this.tournaments!.push(AgeCategoryInTournament.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AgeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["minAge"] = this.minAge;
        data["maxAge"] = this.maxAge;
        data["name"] = this.name;
        if (Array.isArray(this.tournaments)) {
            data["tournaments"] = [];
            for (let item of this.tournaments)
                data["tournaments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAgeCategory {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    minAge: number;
    maxAge: number;
    name: string;
    tournaments?: AgeCategoryInTournament[] | undefined;
}

export class AgeCategoryInTournament implements IAgeCategoryInTournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    sortOrder?: number;
    maxAge?: number | undefined;
    isOpenEnded?: boolean;
    name?: string | undefined;
    gender?: Gender | undefined;

    constructor(data?: IAgeCategoryInTournament) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.tournamentId = _data["tournamentId"];
            this.tournament = _data["tournament"] ? Tournament.fromJS(_data["tournament"]) : undefined as any;
            this.sortOrder = _data["sortOrder"];
            this.maxAge = _data["maxAge"];
            this.isOpenEnded = _data["isOpenEnded"];
            this.name = _data["name"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): AgeCategoryInTournament {
        data = typeof data === 'object' ? data : {};
        let result = new AgeCategoryInTournament();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["tournamentId"] = this.tournamentId;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined as any;
        data["sortOrder"] = this.sortOrder;
        data["maxAge"] = this.maxAge;
        data["isOpenEnded"] = this.isOpenEnded;
        data["name"] = this.name;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IAgeCategoryInTournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    sortOrder?: number;
    maxAge?: number | undefined;
    isOpenEnded?: boolean;
    name?: string | undefined;
    gender?: Gender | undefined;
}

export class ApproveBracketRequest implements IApproveBracketRequest {
    tournamentId?: number;
    weightCategoryInTournamentId?: number;
    ageCategoryInTournamentId?: number;
    rounds?: RoundApproveDto[] | undefined;
    format?: string | undefined;
    isFormatOverridden?: boolean;
    groupAssignments?: MixedGroupAssignmentDto[] | undefined;

    constructor(data?: IApproveBracketRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.weightCategoryInTournamentId = _data["weightCategoryInTournamentId"];
            this.ageCategoryInTournamentId = _data["ageCategoryInTournamentId"];
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(RoundApproveDto.fromJS(item));
            }
            this.format = _data["format"];
            this.isFormatOverridden = _data["isFormatOverridden"];
            if (Array.isArray(_data["groupAssignments"])) {
                this.groupAssignments = [] as any;
                for (let item of _data["groupAssignments"])
                    this.groupAssignments!.push(MixedGroupAssignmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApproveBracketRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveBracketRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["weightCategoryInTournamentId"] = this.weightCategoryInTournamentId;
        data["ageCategoryInTournamentId"] = this.ageCategoryInTournamentId;
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item ? item.toJSON() : undefined as any);
        }
        data["format"] = this.format;
        data["isFormatOverridden"] = this.isFormatOverridden;
        if (Array.isArray(this.groupAssignments)) {
            data["groupAssignments"] = [];
            for (let item of this.groupAssignments)
                data["groupAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApproveBracketRequest {
    tournamentId?: number;
    weightCategoryInTournamentId?: number;
    ageCategoryInTournamentId?: number;
    rounds?: RoundApproveDto[] | undefined;
    format?: string | undefined;
    isFormatOverridden?: boolean;
    groupAssignments?: MixedGroupAssignmentDto[] | undefined;
}

export class MixedGroupAssignmentDto implements IMixedGroupAssignmentDto {
    participantId?: number;
    groupIndex?: number;

    constructor(data?: IMixedGroupAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.groupIndex = _data["groupIndex"];
        }
    }

    static fromJS(data: any): MixedGroupAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MixedGroupAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["groupIndex"] = this.groupIndex;
        return data;
    }
}

export interface IMixedGroupAssignmentDto {
    participantId?: number;
    groupIndex?: number;
}

export class BracketDetailsModel implements IBracketDetailsModel {
    id?: number;
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    format?: string | undefined;
    isFormatOverridden?: boolean;
    matches?: Match[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
    groups?: MixedGroupDetailsModel[] | undefined;
    playoff?: BracketPlayoffDetailsModel | undefined;
    phase?: string | undefined;
    groupStageFinished?: boolean;
    playoffBracketId?: number | undefined;

    constructor(data?: IBracketDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tournamentId = _data["tournamentId"];
            this.tournamentName = _data["tournamentName"];
            this.weightCategory = _data["weightCategory"];
            this.ageCategory = _data["ageCategory"];
            this.format = _data["format"];
            this.isFormatOverridden = _data["isFormatOverridden"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(Match.fromJS(item));
            }
            if (Array.isArray(_data["standings"])) {
                this.standings = [] as any;
                for (let item of _data["standings"])
                    this.standings!.push(RoundRobinStandingModel.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(MixedGroupDetailsModel.fromJS(item));
            }
            if (_data["playoff"]) {
                this.playoff = BracketPlayoffDetailsModel.fromJS(_data["playoff"]);
            }
            this.phase = _data["phase"];
            this.groupStageFinished = _data["groupStageFinished"];
            this.playoffBracketId = _data["playoffBracketId"];
        }
    }

    static fromJS(data: any): BracketDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BracketDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tournamentId"] = this.tournamentId;
        data["tournamentName"] = this.tournamentName;
        data["weightCategory"] = this.weightCategory;
        data["ageCategory"] = this.ageCategory;
        data["format"] = this.format;
        data["isFormatOverridden"] = this.isFormatOverridden;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.standings)) {
            data["standings"] = [];
            for (let item of this.standings)
                data["standings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.playoff) {
            data["playoff"] = this.playoff.toJSON();
        }
        data["phase"] = this.phase;
        data["groupStageFinished"] = this.groupStageFinished;
        data["playoffBracketId"] = this.playoffBracketId;
        return data;
    }
}

export interface IBracketDetailsModel {
    id?: number;
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    format?: string | undefined;
    isFormatOverridden?: boolean;
    matches?: Match[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
    groups?: MixedGroupDetailsModel[] | undefined;
    playoff?: BracketPlayoffDetailsModel | undefined;
    phase?: string | undefined;
    groupStageFinished?: boolean;
    playoffBracketId?: number | undefined;
}

export class MixedGroupDetailsModel implements IMixedGroupDetailsModel {
    id?: number;
    groupIndex?: number;
    expectedSize?: number;
    matches?: Match[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;

    constructor(data?: IMixedGroupDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupIndex = _data["groupIndex"];
            this.expectedSize = _data["expectedSize"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(Match.fromJS(item));
            }
            if (Array.isArray(_data["standings"])) {
                this.standings = [] as any;
                for (let item of _data["standings"])
                    this.standings!.push(RoundRobinStandingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MixedGroupDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MixedGroupDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupIndex"] = this.groupIndex;
        data["expectedSize"] = this.expectedSize;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.standings)) {
            data["standings"] = [];
            for (let item of this.standings)
                data["standings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMixedGroupDetailsModel {
    id?: number;
    groupIndex?: number;
    expectedSize?: number;
    matches?: Match[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
}

export class BracketPlayoffDetailsModel implements IBracketPlayoffDetailsModel {
    id?: number;
    matches?: Match[] | undefined;

    constructor(data?: IBracketPlayoffDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(Match.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BracketPlayoffDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BracketPlayoffDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBracketPlayoffDetailsModel {
    id?: number;
    matches?: Match[] | undefined;
}

export class BracketPreviewModel implements IBracketPreviewModel {
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    format?: string | undefined;
    autoDetectedFormat?: string | undefined;
    isFormatOverridden?: boolean;
    tournamentType?: string | undefined;
    rounds?: RoundPreviewModel[] | undefined;
    participants?: CategoryParticipantModel[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;

    constructor(data?: IBracketPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.tournamentName = _data["tournamentName"];
            this.weightCategory = _data["weightCategory"];
            this.ageCategory = _data["ageCategory"];
            this.format = _data["format"];
            this.autoDetectedFormat = _data["autoDetectedFormat"];
            this.isFormatOverridden = _data["isFormatOverridden"];
            this.tournamentType = _data["tournamentType"];
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(RoundPreviewModel.fromJS(item));
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(CategoryParticipantModel.fromJS(item));
            }
            if (Array.isArray(_data["standings"])) {
                this.standings = [] as any;
                for (let item of _data["standings"])
                    this.standings!.push(RoundRobinStandingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BracketPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BracketPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["tournamentName"] = this.tournamentName;
        data["weightCategory"] = this.weightCategory;
        data["ageCategory"] = this.ageCategory;
        data["format"] = this.format;
        data["autoDetectedFormat"] = this.autoDetectedFormat;
        data["isFormatOverridden"] = this.isFormatOverridden;
        data["tournamentType"] = this.tournamentType;
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.standings)) {
            data["standings"] = [];
            for (let item of this.standings)
                data["standings"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBracketPreviewModel {
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    format?: string | undefined;
    autoDetectedFormat?: string | undefined;
    isFormatOverridden?: boolean;
    tournamentType?: string | undefined;
    rounds?: RoundPreviewModel[] | undefined;
    participants?: CategoryParticipantModel[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
}

export enum BracketType {
    Main = "Main",
    Repechage = "Repechage",
}

export enum RepechageSide {
    Left = "Left",
    Right = "Right",
}

export class RepechageBracketsModel implements IRepechageBracketsModel {
    leftRepechageBracketId?: number | null;
    rightRepechageBracketId?: number | null;

    constructor(data?: IRepechageBracketsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leftRepechageBracketId = _data["leftRepechageBracketId"];
            this.rightRepechageBracketId = _data["rightRepechageBracketId"];
        }
    }

    static fromJS(data: any): RepechageBracketsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepechageBracketsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leftRepechageBracketId"] = this.leftRepechageBracketId;
        data["rightRepechageBracketId"] = this.rightRepechageBracketId;
        return data;
    }
}

export interface IRepechageBracketsModel {
    leftRepechageBracketId?: number | null;
    rightRepechageBracketId?: number | null;
}

export class CategoryDrawModel implements ICategoryDrawModel {
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    participantCount?: number;
    format?: string | undefined;
    autoDetectedFormat?: string | undefined;
    isFormatOverridden?: boolean;
    participants?: CategoryParticipantModel[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
    rounds?: RoundPreviewModel[] | undefined;

    constructor(data?: ICategoryDrawModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tournamentId = _data["tournamentId"];
            this.tournamentName = _data["tournamentName"];
            this.weightCategory = _data["weightCategory"];
            this.ageCategory = _data["ageCategory"];
            this.participantCount = _data["participantCount"];
            this.format = _data["format"];
            this.autoDetectedFormat = _data["autoDetectedFormat"];
            this.isFormatOverridden = _data["isFormatOverridden"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(CategoryParticipantModel.fromJS(item));
            }
            if (Array.isArray(_data["standings"])) {
                this.standings = [] as any;
                for (let item of _data["standings"])
                    this.standings!.push(RoundRobinStandingModel.fromJS(item));
            }
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(RoundPreviewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CategoryDrawModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDrawModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId;
        data["tournamentName"] = this.tournamentName;
        data["weightCategory"] = this.weightCategory;
        data["ageCategory"] = this.ageCategory;
        data["participantCount"] = this.participantCount;
        data["format"] = this.format;
        data["autoDetectedFormat"] = this.autoDetectedFormat;
        data["isFormatOverridden"] = this.isFormatOverridden;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.standings)) {
            data["standings"] = [];
            for (let item of this.standings)
                data["standings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICategoryDrawModel {
    tournamentId?: number;
    tournamentName?: string | undefined;
    weightCategory?: string | undefined;
    ageCategory?: string | undefined;
    participantCount?: number;
    format?: string | undefined;
    autoDetectedFormat?: string | undefined;
    isFormatOverridden?: boolean;
    participants?: CategoryParticipantModel[] | undefined;
    standings?: RoundRobinStandingModel[] | undefined;
    rounds?: RoundPreviewModel[] | undefined;
}

export class CategoryParticipantModel implements ICategoryParticipantModel {
    id?: number;
    personName?: string | undefined;
    organization?: string | undefined;
    weight?: number;
    rank?: string | undefined;

    constructor(data?: ICategoryParticipantModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personName = _data["personName"];
            this.organization = _data["organization"];
            this.weight = _data["weight"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): CategoryParticipantModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryParticipantModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personName"] = this.personName;
        data["organization"] = this.organization;
        data["weight"] = this.weight;
        data["rank"] = this.rank;
        return data;
    }
}

export interface ICategoryParticipantModel {
    id?: number;
    personName?: string | undefined;
    organization?: string | undefined;
    weight?: number;
    rank?: string | undefined;
}

export enum CompetitionFormat {
    Olympic = "Olympic",
    RoundRobin = "RoundRobin",
    Mixed = "Mixed",
}

export enum Gender {
    Male = "Male",
    Female = "Female",
}

export class ConfigModel implements IConfigModel {
    scoreTypes?: string[] | undefined;
    competitionFormats?: string[] | undefined;
    rankOptions?: string[] | undefined;

    constructor(data?: IConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scoreTypes"])) {
                this.scoreTypes = [] as any;
                for (let item of _data["scoreTypes"])
                    this.scoreTypes!.push(item);
            }
            if (Array.isArray(_data["competitionFormats"])) {
                this.competitionFormats = [] as any;
                for (let item of _data["competitionFormats"])
                    this.competitionFormats!.push(item);
            }
            if (Array.isArray(_data["rankOptions"])) {
                this.rankOptions = [] as any;
                for (let item of _data["rankOptions"])
                    this.rankOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scoreTypes)) {
            data["scoreTypes"] = [];
            for (let item of this.scoreTypes)
                data["scoreTypes"].push(item);
        }
        if (Array.isArray(this.competitionFormats)) {
            data["competitionFormats"] = [];
            for (let item of this.competitionFormats)
                data["competitionFormats"].push(item);
        }
        if (Array.isArray(this.rankOptions)) {
            data["rankOptions"] = [];
            for (let item of this.rankOptions)
                data["rankOptions"].push(item);
        }
        return data;
    }
}

export interface IConfigModel {
    scoreTypes?: string[] | undefined;
    competitionFormats?: string[] | undefined;
    rankOptions?: string[] | undefined;
}

export class CreateRepechageRequest implements ICreateRepechageRequest {
    mainBracketId?: number;
    side?: RepechageSide;
    rounds?: RoundApproveDto[] | undefined;

    constructor(data?: ICreateRepechageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainBracketId = _data["mainBracketId"];
            this.side = _data["side"];
            if (Array.isArray(_data["rounds"])) {
                this.rounds = [] as any;
                for (let item of _data["rounds"])
                    this.rounds!.push(RoundApproveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateRepechageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRepechageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainBracketId"] = this.mainBracketId;
        data["side"] = this.side;
        if (Array.isArray(this.rounds)) {
            data["rounds"] = [];
            for (let item of this.rounds)
                data["rounds"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateRepechageRequest {
    mainBracketId?: number;
    side?: RepechageSide;
    rounds?: RoundApproveDto[] | undefined;
}

export class EndMatchModel implements IEndMatchModel {
    isHomeWinner!: boolean;

    constructor(data?: IEndMatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHomeWinner = _data["isHomeWinner"];
        }
    }

    static fromJS(data: any): EndMatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndMatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHomeWinner"] = this.isHomeWinner;
        return data;
    }
}

export interface IEndMatchModel {
    isHomeWinner: boolean;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email!: string;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordModel {
    email: string;
}

export class LoginModel implements ILoginModel {
    email!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModel {
    email: string;
    password: string;
}

export class Match implements IMatch {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentBracketId?: number;
    homeParticipantId?: number | undefined;
    homeParticipant?: Participant;
    awayParticipantId?: number | undefined;
    awayParticipant?: Participant;
    round?: number;
    nextMatchId?: number | undefined;
    isHomeWinner?: boolean | undefined;
    homeScoreIppon?: number | undefined;
    homeScoreWazaAri?: number | undefined;
    homeScoreYuko?: number | undefined;
    awayScoreIppon?: number | undefined;
    awayScoreWazaAri?: number | undefined;
    awayScoreYuko?: number | undefined;
    homeShido?: number | undefined;
    awayShido?: number | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    pausedTime?: TimeSpan;
    isPaused?: boolean;
    lastPausedAt?: Date | undefined;
    order?: number;

    constructor(data?: IMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.tournamentBracketId = _data["tournamentBracketId"];
            this.homeParticipantId = _data["homeParticipantId"];
            this.homeParticipant = _data["homeParticipant"] ? Participant.fromJS(_data["homeParticipant"]) : undefined as any;
            this.awayParticipantId = _data["awayParticipantId"];
            this.awayParticipant = _data["awayParticipant"] ? Participant.fromJS(_data["awayParticipant"]) : undefined as any;
            this.round = _data["round"];
            this.nextMatchId = _data["nextMatchId"];
            this.isHomeWinner = _data["isHomeWinner"];
            this.homeScoreIppon = _data["homeScoreIppon"];
            this.homeScoreWazaAri = _data["homeScoreWazaAri"];
            this.homeScoreYuko = _data["homeScoreYuko"];
            this.awayScoreIppon = _data["awayScoreIppon"];
            this.awayScoreWazaAri = _data["awayScoreWazaAri"];
            this.awayScoreYuko = _data["awayScoreYuko"];
            this.homeShido = _data["homeShido"];
            this.awayShido = _data["awayShido"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.pausedTime = _data["pausedTime"] ? TimeSpan.fromJS(_data["pausedTime"]) : undefined as any;
            this.isPaused = _data["isPaused"];
            this.lastPausedAt = _data["lastPausedAt"] ? new Date(_data["lastPausedAt"].toString()) : undefined as any;
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): Match {
        data = typeof data === 'object' ? data : {};
        let result = new Match();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["tournamentBracketId"] = this.tournamentBracketId;
        data["homeParticipantId"] = this.homeParticipantId;
        data["homeParticipant"] = this.homeParticipant ? this.homeParticipant.toJSON() : undefined as any;
        data["awayParticipantId"] = this.awayParticipantId;
        data["awayParticipant"] = this.awayParticipant ? this.awayParticipant.toJSON() : undefined as any;
        data["round"] = this.round;
        data["nextMatchId"] = this.nextMatchId;
        data["isHomeWinner"] = this.isHomeWinner;
        data["homeScoreIppon"] = this.homeScoreIppon;
        data["homeScoreWazaAri"] = this.homeScoreWazaAri;
        data["homeScoreYuko"] = this.homeScoreYuko;
        data["awayScoreIppon"] = this.awayScoreIppon;
        data["awayScoreWazaAri"] = this.awayScoreWazaAri;
        data["awayScoreYuko"] = this.awayScoreYuko;
        data["homeShido"] = this.homeShido;
        data["awayShido"] = this.awayShido;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["pausedTime"] = this.pausedTime ? this.pausedTime.toJSON() : undefined as any;
        data["isPaused"] = this.isPaused;
        data["lastPausedAt"] = this.lastPausedAt ? this.lastPausedAt.toISOString() : undefined as any;
        data["order"] = this.order;
        return data;
    }
}

export interface IMatch {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentBracketId?: number;
    homeParticipantId?: number | undefined;
    homeParticipant?: Participant;
    awayParticipantId?: number | undefined;
    awayParticipant?: Participant;
    round?: number;
    nextMatchId?: number | undefined;
    isHomeWinner?: boolean | undefined;
    homeScoreIppon?: number | undefined;
    homeScoreWazaAri?: number | undefined;
    homeScoreYuko?: number | undefined;
    awayScoreIppon?: number | undefined;
    awayScoreWazaAri?: number | undefined;
    awayScoreYuko?: number | undefined;
    homeShido?: number | undefined;
    awayShido?: number | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    pausedTime?: TimeSpan;
    isPaused?: boolean;
    lastPausedAt?: Date | undefined;
    order?: number;
}

export class MatchApproveDto implements IMatchApproveDto {
    homeParticipantId?: number | undefined;
    awayParticipantId?: number | undefined;

    constructor(data?: IMatchApproveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homeParticipantId = _data["homeParticipantId"];
            this.awayParticipantId = _data["awayParticipantId"];
        }
    }

    static fromJS(data: any): MatchApproveDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatchApproveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeParticipantId"] = this.homeParticipantId;
        data["awayParticipantId"] = this.awayParticipantId;
        return data;
    }
}

export interface IMatchApproveDto {
    homeParticipantId?: number | undefined;
    awayParticipantId?: number | undefined;
}

export class MatchFinalResultModel implements IMatchFinalResultModel {
    isHomeWinner!: boolean;
    homeScoreIppon?: number;
    homeScoreWazaAri?: number;
    homeScoreYuko?: number;
    awayScoreIppon?: number;
    awayScoreWazaAri?: number;
    awayScoreYuko?: number;
    homeShido?: number;
    awayShido?: number;
    startTime?: Date | undefined;
    pausedMilliseconds?: number;

    constructor(data?: IMatchFinalResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isHomeWinner = _data["isHomeWinner"];
            this.homeScoreIppon = _data["homeScoreIppon"];
            this.homeScoreWazaAri = _data["homeScoreWazaAri"];
            this.homeScoreYuko = _data["homeScoreYuko"];
            this.awayScoreIppon = _data["awayScoreIppon"];
            this.awayScoreWazaAri = _data["awayScoreWazaAri"];
            this.awayScoreYuko = _data["awayScoreYuko"];
            this.homeShido = _data["homeShido"];
            this.awayShido = _data["awayShido"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.pausedMilliseconds = _data["pausedMilliseconds"];
        }
    }

    static fromJS(data: any): MatchFinalResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatchFinalResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isHomeWinner"] = this.isHomeWinner;
        data["homeScoreIppon"] = this.homeScoreIppon;
        data["homeScoreWazaAri"] = this.homeScoreWazaAri;
        data["homeScoreYuko"] = this.homeScoreYuko;
        data["awayScoreIppon"] = this.awayScoreIppon;
        data["awayScoreWazaAri"] = this.awayScoreWazaAri;
        data["awayScoreYuko"] = this.awayScoreYuko;
        data["homeShido"] = this.homeShido;
        data["awayShido"] = this.awayShido;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["pausedMilliseconds"] = this.pausedMilliseconds;
        return data;
    }
}

export interface IMatchFinalResultModel {
    isHomeWinner: boolean;
    homeScoreIppon?: number;
    homeScoreWazaAri?: number;
    homeScoreYuko?: number;
    awayScoreIppon?: number;
    awayScoreWazaAri?: number;
    awayScoreYuko?: number;
    homeShido?: number;
    awayShido?: number;
    startTime?: Date | undefined;
    pausedMilliseconds?: number;
}

export class MatchPreviewModel implements IMatchPreviewModel {
    homeParticipantId?: number | undefined;
    homeParticipantName?: string | undefined;
    homeParticipantCity?: string | undefined;
    awayParticipantId?: number | undefined;
    awayParticipantName?: string | undefined;
    awayParticipantCity?: string | undefined;

    constructor(data?: IMatchPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homeParticipantId = _data["homeParticipantId"];
            this.homeParticipantName = _data["homeParticipantName"];
            this.homeParticipantCity = _data["homeParticipantCity"];
            this.awayParticipantId = _data["awayParticipantId"];
            this.awayParticipantName = _data["awayParticipantName"];
            this.awayParticipantCity = _data["awayParticipantCity"];
        }
    }

    static fromJS(data: any): MatchPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeParticipantId"] = this.homeParticipantId;
        data["homeParticipantName"] = this.homeParticipantName;
        data["homeParticipantCity"] = this.homeParticipantCity;
        data["awayParticipantId"] = this.awayParticipantId;
        data["awayParticipantName"] = this.awayParticipantName;
        data["awayParticipantCity"] = this.awayParticipantCity;
        return data;
    }
}

export interface IMatchPreviewModel {
    homeParticipantId?: number | undefined;
    homeParticipantName?: string | undefined;
    homeParticipantCity?: string | undefined;
    awayParticipantId?: number | undefined;
    awayParticipantName?: string | undefined;
    awayParticipantCity?: string | undefined;
}

export class NewsModel implements INewsModel {
    upcomingTournaments?: TournamentNewsItem[] | undefined;
    pastTournaments?: TournamentNewsItem[] | undefined;
    activeTournaments?: TournamentNewsItem[] | undefined;

    constructor(data?: INewsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["upcomingTournaments"])) {
                this.upcomingTournaments = [] as any;
                for (let item of _data["upcomingTournaments"])
                    this.upcomingTournaments!.push(TournamentNewsItem.fromJS(item));
            }
            if (Array.isArray(_data["pastTournaments"])) {
                this.pastTournaments = [] as any;
                for (let item of _data["pastTournaments"])
                    this.pastTournaments!.push(TournamentNewsItem.fromJS(item));
            }
            if (Array.isArray(_data["activeTournaments"])) {
                this.activeTournaments = [] as any;
                for (let item of _data["activeTournaments"])
                    this.activeTournaments!.push(TournamentNewsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewsModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.upcomingTournaments)) {
            data["upcomingTournaments"] = [];
            for (let item of this.upcomingTournaments)
                data["upcomingTournaments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pastTournaments)) {
            data["pastTournaments"] = [];
            for (let item of this.pastTournaments)
                data["pastTournaments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeTournaments)) {
            data["activeTournaments"] = [];
            for (let item of this.activeTournaments)
                data["activeTournaments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INewsModel {
    upcomingTournaments?: TournamentNewsItem[] | undefined;
    pastTournaments?: TournamentNewsItem[] | undefined;
    activeTournaments?: TournamentNewsItem[] | undefined;
}

export class Participant implements IParticipant {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    personId?: number;
    person?: Person;
    tournamentId?: number;
    tournament?: Tournament;
    weight!: number;
    organization!: string;
    coachId?: number | undefined;
    coach?: Person;
    rank?: string | undefined;
    weightCategoryInTournamentId?: number | undefined;
    weightCategoryInTournament?: WeightCategoryInTournament;
    ageCategoryInTournamentId?: number | undefined;
    ageCategoryInTournament?: AgeCategoryInTournament;

    constructor(data?: IParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.tournamentId = _data["tournamentId"];
            this.tournament = _data["tournament"] ? Tournament.fromJS(_data["tournament"]) : undefined as any;
            this.weight = _data["weight"];
            this.organization = _data["organization"];
            this.coachId = _data["coachId"];
            this.coach = _data["coach"] ? Person.fromJS(_data["coach"]) : undefined as any;
            this.rank = _data["rank"];
            this.weightCategoryInTournamentId = _data["weightCategoryInTournamentId"];
            this.weightCategoryInTournament = _data["weightCategoryInTournament"] ? WeightCategoryInTournament.fromJS(_data["weightCategoryInTournament"]) : undefined as any;
            this.ageCategoryInTournamentId = _data["ageCategoryInTournamentId"];
            this.ageCategoryInTournament = _data["ageCategoryInTournament"] ? AgeCategoryInTournament.fromJS(_data["ageCategoryInTournament"]) : undefined as any;
        }
    }

    static fromJS(data: any): Participant {
        data = typeof data === 'object' ? data : {};
        let result = new Participant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["tournamentId"] = this.tournamentId;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined as any;
        data["weight"] = this.weight;
        data["organization"] = this.organization;
        data["coachId"] = this.coachId;
        data["coach"] = this.coach ? this.coach.toJSON() : undefined as any;
        data["rank"] = this.rank;
        data["weightCategoryInTournamentId"] = this.weightCategoryInTournamentId;
        data["weightCategoryInTournament"] = this.weightCategoryInTournament ? this.weightCategoryInTournament.toJSON() : undefined as any;
        data["ageCategoryInTournamentId"] = this.ageCategoryInTournamentId;
        data["ageCategoryInTournament"] = this.ageCategoryInTournament ? this.ageCategoryInTournament.toJSON() : undefined as any;
        return data;
    }
}

export interface IParticipant {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    personId?: number;
    person?: Person;
    tournamentId?: number;
    tournament?: Tournament;
    weight: number;
    organization: string;
    coachId?: number | undefined;
    coach?: Person;
    rank?: string | undefined;
    weightCategoryInTournamentId?: number | undefined;
    weightCategoryInTournament?: WeightCategoryInTournament;
    ageCategoryInTournamentId?: number | undefined;
    ageCategoryInTournament?: AgeCategoryInTournament;
}

export class ParticipantDto implements IParticipantDto {
    id?: number | undefined;
    personId!: number;
    tournamentId!: number;
    weight!: number;
    organization!: string;
    coachId?: number | undefined;
    rank?: string | undefined;
    ageCategoryInTournamentId?: number | undefined;
    weightCategoryInTournamentId?: number | undefined;

    constructor(data?: IParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.tournamentId = _data["tournamentId"];
            this.weight = _data["weight"];
            this.organization = _data["organization"];
            this.coachId = _data["coachId"];
            this.rank = _data["rank"];
            this.ageCategoryInTournamentId = _data["ageCategoryInTournamentId"];
            this.weightCategoryInTournamentId = _data["weightCategoryInTournamentId"];
        }
    }

    static fromJS(data: any): ParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["tournamentId"] = this.tournamentId;
        data["weight"] = this.weight;
        data["organization"] = this.organization;
        data["coachId"] = this.coachId;
        data["rank"] = this.rank;
        data["ageCategoryInTournamentId"] = this.ageCategoryInTournamentId;
        data["weightCategoryInTournamentId"] = this.weightCategoryInTournamentId;
        return data;
    }
}

export interface IParticipantDto {
    id?: number | undefined;
    personId: number;
    tournamentId: number;
    weight: number;
    organization: string;
    coachId?: number | undefined;
    rank?: string | undefined;
    ageCategoryInTournamentId?: number | undefined;
    weightCategoryInTournamentId?: number | undefined;
}

export class Person implements IPerson {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    lastName!: string;
    firstName!: string;
    patronymic?: string | undefined;
    birthDate!: Date;
    city!: string;
    email!: string;
    gender?: Gender | undefined;
    passwordHash!: string;
    personRoles?: PersonRole[] | undefined;
    participants?: Participant[] | undefined;
    trainedParticipants?: Participant[] | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.patronymic = _data["patronymic"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.city = _data["city"];
            this.email = _data["email"];
            this.gender = _data["gender"];
            this.passwordHash = _data["passwordHash"];
            if (Array.isArray(_data["personRoles"])) {
                this.personRoles = [] as any;
                for (let item of _data["personRoles"])
                    this.personRoles!.push(PersonRole.fromJS(item));
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(Participant.fromJS(item));
            }
            if (Array.isArray(_data["trainedParticipants"])) {
                this.trainedParticipants = [] as any;
                for (let item of _data["trainedParticipants"])
                    this.trainedParticipants!.push(Participant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["patronymic"] = this.patronymic;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["city"] = this.city;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["passwordHash"] = this.passwordHash;
        if (Array.isArray(this.personRoles)) {
            data["personRoles"] = [];
            for (let item of this.personRoles)
                data["personRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.trainedParticipants)) {
            data["trainedParticipants"] = [];
            for (let item of this.trainedParticipants)
                data["trainedParticipants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPerson {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    lastName: string;
    firstName: string;
    patronymic?: string | undefined;
    birthDate: Date;
    city: string;
    email: string;
    gender?: Gender | undefined;
    passwordHash: string;
    personRoles?: PersonRole[] | undefined;
    participants?: Participant[] | undefined;
    trainedParticipants?: Participant[] | undefined;
}

export class PersonCreateModel implements IPersonCreateModel {
    lastName!: string;
    firstName!: string;
    patronymic?: string | undefined;
    birthDate!: Date;
    city!: string;
    email?: string | undefined;
    roleIds?: number[] | undefined;
    gender?: Gender | undefined;

    constructor(data?: IPersonCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.patronymic = _data["patronymic"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.city = _data["city"];
            this.email = _data["email"];
            this.gender = _data["gender"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["patronymic"] = this.patronymic;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["city"] = this.city;
        data["email"] = this.email;
        data["gender"] = this.gender;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IPersonCreateModel {
    lastName: string;
    firstName: string;
    patronymic?: string | undefined;
    birthDate: Date;
    city: string;
    email?: string | undefined;
    roleIds?: number[] | undefined;
    gender?: Gender | undefined;
}

export class PersonRole implements IPersonRole {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    personId?: number;
    person?: Person;
    roleId?: number;
    role?: Role;

    constructor(data?: IPersonRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.personId = _data["personId"];
            this.person = _data["person"] ? Person.fromJS(_data["person"]) : undefined as any;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): PersonRole {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : undefined as any;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IPersonRole {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    personId?: number;
    person?: Person;
    roleId?: number;
    role?: Role;
}

export class RegisterModel implements IRegisterModel {
    lastName!: string;
    firstName!: string;
    patronymic?: string | undefined;
    birthDate!: Date;
    city!: string;
    email!: string;
    password!: string;
    roleIds?: number[] | undefined;

    constructor(data?: IRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.patronymic = _data["patronymic"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.city = _data["city"];
            this.email = _data["email"];
            this.password = _data["password"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["patronymic"] = this.patronymic;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["city"] = this.city;
        data["email"] = this.email;
        data["password"] = this.password;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        return data;
    }
}

export interface IRegisterModel {
    lastName: string;
    firstName: string;
    patronymic?: string | undefined;
    birthDate: Date;
    city: string;
    email: string;
    password: string;
    roleIds?: number[] | undefined;
}

export class Role implements IRole {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    name!: string;
    personRoles?: PersonRole[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.name = _data["name"];
            if (Array.isArray(_data["personRoles"])) {
                this.personRoles = [] as any;
                for (let item of _data["personRoles"])
                    this.personRoles!.push(PersonRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["name"] = this.name;
        if (Array.isArray(this.personRoles)) {
            data["personRoles"] = [];
            for (let item of this.personRoles)
                data["personRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRole {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    name: string;
    personRoles?: PersonRole[] | undefined;
}

export class RoundApproveDto implements IRoundApproveDto {
    roundNumber?: number;
    matches?: MatchApproveDto[] | undefined;

    constructor(data?: IRoundApproveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roundNumber = _data["roundNumber"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchApproveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoundApproveDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoundApproveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roundNumber"] = this.roundNumber;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoundApproveDto {
    roundNumber?: number;
    matches?: MatchApproveDto[] | undefined;
}

export class RoundPreviewModel implements IRoundPreviewModel {
    round?: number;
    matches?: MatchPreviewModel[] | undefined;

    constructor(data?: IRoundPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.round = _data["round"];
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchPreviewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoundPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoundPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["round"] = this.round;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoundPreviewModel {
    round?: number;
    matches?: MatchPreviewModel[] | undefined;
}

export class RoundRobinStandingModel implements IRoundRobinStandingModel {
    participantId?: number;
    personName?: string | undefined;
    organization?: string | undefined;
    wins?: number;
    losses?: number;
    points?: number;
    ippons?: number;
    place?: number | undefined;

    constructor(data?: IRoundRobinStandingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.personName = _data["personName"];
            this.organization = _data["organization"];
            this.wins = _data["wins"];
            this.losses = _data["losses"];
            this.points = _data["points"];
            this.ippons = _data["ippons"];
            this.place = _data["place"];
        }
    }

    static fromJS(data: any): RoundRobinStandingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoundRobinStandingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["personName"] = this.personName;
        data["organization"] = this.organization;
        data["wins"] = this.wins;
        data["losses"] = this.losses;
        data["points"] = this.points;
        data["ippons"] = this.ippons;
        data["place"] = this.place;
        return data;
    }
}

export interface IRoundRobinStandingModel {
    participantId?: number;
    personName?: string | undefined;
    organization?: string | undefined;
    wins?: number;
    losses?: number;
    points?: number;
    ippons?: number;
    place?: number | undefined;
}

export class ScoreModel implements IScoreModel {
    scoreType!: ScoreType;
    isHome!: boolean;

    constructor(data?: IScoreModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scoreType = _data["scoreType"];
            this.isHome = _data["isHome"];
        }
    }

    static fromJS(data: any): ScoreModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoreModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scoreType"] = this.scoreType;
        data["isHome"] = this.isHome;
        return data;
    }
}

export interface IScoreModel {
    scoreType: ScoreType;
    isHome: boolean;
}

export enum ScoreType {
    Ippon = "Ippon",
    WazaAri = "WazaAri",
    Yuko = "Yuko",
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly microseconds?: number;
    readonly nanoseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMicroseconds?: number;
    readonly totalNanoseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (this as any).days = _data["days"];
            (this as any).hours = _data["hours"];
            (this as any).milliseconds = _data["milliseconds"];
            (this as any).microseconds = _data["microseconds"];
            (this as any).nanoseconds = _data["nanoseconds"];
            (this as any).minutes = _data["minutes"];
            (this as any).seconds = _data["seconds"];
            (this as any).totalDays = _data["totalDays"];
            (this as any).totalHours = _data["totalHours"];
            (this as any).totalMilliseconds = _data["totalMilliseconds"];
            (this as any).totalMicroseconds = _data["totalMicroseconds"];
            (this as any).totalNanoseconds = _data["totalNanoseconds"];
            (this as any).totalMinutes = _data["totalMinutes"];
            (this as any).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["microseconds"] = this.microseconds;
        data["nanoseconds"] = this.nanoseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMicroseconds"] = this.totalMicroseconds;
        data["totalNanoseconds"] = this.totalNanoseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    microseconds?: number;
    nanoseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMicroseconds?: number;
    totalNanoseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class Tournament implements ITournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    name!: string;
    startDate!: Date;
    endDate!: Date;
    registrationEndDate!: Date;
    location!: string;
    durationInMinutes!: number;
    isStarted?: boolean;
    isFinished?: boolean;
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weighInProtocolTitle?: string | undefined;
    competitionProtocolTitle?: string | undefined;
    weightCategories?: WeightCategoryInTournament[] | undefined;
    ageCategories?: AgeCategoryInTournament[] | undefined;

    constructor(data?: ITournament) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.registrationEndDate = _data["registrationEndDate"] ? new Date(_data["registrationEndDate"].toString()) : undefined as any;
            this.location = _data["location"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.isStarted = _data["isStarted"];
            this.isFinished = _data["isFinished"];
            this.chiefJudgeName = _data["chiefJudgeName"];
            this.chiefSecretaryName = _data["chiefSecretaryName"];
            this.weighInProtocolTitle = _data["weighInProtocolTitle"];
            this.competitionProtocolTitle = _data["competitionProtocolTitle"];
            if (Array.isArray(_data["weightCategories"])) {
                this.weightCategories = [] as any;
                for (let item of _data["weightCategories"])
                    this.weightCategories!.push(WeightCategoryInTournament.fromJS(item));
            }
            if (Array.isArray(_data["ageCategories"])) {
                this.ageCategories = [] as any;
                for (let item of _data["ageCategories"])
                    this.ageCategories!.push(AgeCategoryInTournament.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tournament {
        data = typeof data === 'object' ? data : {};
        let result = new Tournament();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["registrationEndDate"] = this.registrationEndDate ? this.registrationEndDate.toISOString() : undefined as any;
        data["location"] = this.location;
        data["durationInMinutes"] = this.durationInMinutes;
        data["isStarted"] = this.isStarted;
        data["isFinished"] = this.isFinished;
        data["chiefJudgeName"] = this.chiefJudgeName;
        data["chiefSecretaryName"] = this.chiefSecretaryName;
        data["weighInProtocolTitle"] = this.weighInProtocolTitle;
        data["competitionProtocolTitle"] = this.competitionProtocolTitle;
        if (Array.isArray(this.weightCategories)) {
            data["weightCategories"] = [];
            for (let item of this.weightCategories)
                data["weightCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ageCategories)) {
            data["ageCategories"] = [];
            for (let item of this.ageCategories)
                data["ageCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    name: string;
    startDate: Date;
    endDate: Date;
    registrationEndDate: Date;
    location: string;
    durationInMinutes: number;
    isStarted?: boolean;
    isFinished?: boolean;
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weighInProtocolTitle?: string | undefined;
    competitionProtocolTitle?: string | undefined;
    weightCategories?: WeightCategoryInTournament[] | undefined;
    ageCategories?: AgeCategoryInTournament[] | undefined;
}

export class TournamentBracket implements ITournamentBracket {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    weightCategoryInTournamentId?: number;
    weightCategoryInTournament?: WeightCategoryInTournament;
    ageCategoryInTournamentId?: number;
    ageCategoryInTournament?: AgeCategoryInTournament;
    format?: CompetitionFormat;
    isFormatOverridden?: boolean;
    bracketType?: BracketType;
    parentBracketId?: number | undefined;

    constructor(data?: ITournamentBracket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.tournamentId = _data["tournamentId"];
            this.tournament = _data["tournament"] ? Tournament.fromJS(_data["tournament"]) : undefined as any;
            this.weightCategoryInTournamentId = _data["weightCategoryInTournamentId"];
            this.weightCategoryInTournament = _data["weightCategoryInTournament"] ? WeightCategoryInTournament.fromJS(_data["weightCategoryInTournament"]) : undefined as any;
            this.ageCategoryInTournamentId = _data["ageCategoryInTournamentId"];
            this.ageCategoryInTournament = _data["ageCategoryInTournament"] ? AgeCategoryInTournament.fromJS(_data["ageCategoryInTournament"]) : undefined as any;
            this.format = _data["format"];
            this.isFormatOverridden = _data["isFormatOverridden"];
            this.bracketType = _data["bracketType"];
            this.parentBracketId = _data["parentBracketId"];
        }
    }

    static fromJS(data: any): TournamentBracket {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentBracket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["tournamentId"] = this.tournamentId;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined as any;
        data["weightCategoryInTournamentId"] = this.weightCategoryInTournamentId;
        data["weightCategoryInTournament"] = this.weightCategoryInTournament ? this.weightCategoryInTournament.toJSON() : undefined as any;
        data["ageCategoryInTournamentId"] = this.ageCategoryInTournamentId;
        data["ageCategoryInTournament"] = this.ageCategoryInTournament ? this.ageCategoryInTournament.toJSON() : undefined as any;
        data["format"] = this.format;
        data["isFormatOverridden"] = this.isFormatOverridden;
        data["bracketType"] = this.bracketType;
        data["parentBracketId"] = this.parentBracketId;
        return data;
    }
}

export interface ITournamentBracket {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    weightCategoryInTournamentId?: number;
    weightCategoryInTournament?: WeightCategoryInTournament;
    ageCategoryInTournamentId?: number;
    ageCategoryInTournament?: AgeCategoryInTournament;
    format?: CompetitionFormat;
    isFormatOverridden?: boolean;
    bracketType?: BracketType;
    parentBracketId?: number | undefined;
}

export class WeightCategoryInput implements IWeightCategoryInput {
    sortOrder!: number;
    maxWeight?: number | undefined;
    isOpenEnded!: boolean;
    gender?: Gender | undefined;

    constructor(data?: IWeightCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.maxWeight = _data["maxWeight"];
            this.isOpenEnded = _data["isOpenEnded"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): WeightCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new WeightCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["maxWeight"] = this.maxWeight;
        data["isOpenEnded"] = this.isOpenEnded;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IWeightCategoryInput {
    sortOrder: number;
    maxWeight?: number | undefined;
    isOpenEnded: boolean;
    gender?: Gender | undefined;
}

export class AgeCategoryInput implements IAgeCategoryInput {
    sortOrder!: number;
    maxAge?: number | undefined;
    isOpenEnded!: boolean;
    name?: string | undefined;
    gender?: Gender | undefined;

    constructor(data?: IAgeCategoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.maxAge = _data["maxAge"];
            this.isOpenEnded = _data["isOpenEnded"];
            this.name = _data["name"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): AgeCategoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new AgeCategoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["maxAge"] = this.maxAge;
        data["isOpenEnded"] = this.isOpenEnded;
        data["name"] = this.name;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IAgeCategoryInput {
    sortOrder: number;
    maxAge?: number | undefined;
    isOpenEnded: boolean;
    name?: string | undefined;
    gender?: Gender | undefined;
}

export class TournamentCreateModel implements ITournamentCreateModel {
    name!: string;
    startDate!: Date;
    endDate!: Date;
    registrationEndDate!: Date;
    location!: string;
    durationInMinutes!: number;
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weightCategories?: WeightCategoryInput[] | undefined;
    ageCategories?: AgeCategoryInput[] | undefined;

    constructor(data?: ITournamentCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.registrationEndDate = _data["registrationEndDate"] ? new Date(_data["registrationEndDate"].toString()) : undefined as any;
            this.location = _data["location"];
            this.durationInMinutes = _data["durationInMinutes"];
            this.chiefJudgeName = _data["chiefJudgeName"];
            this.chiefSecretaryName = _data["chiefSecretaryName"];
            if (Array.isArray(_data["weightCategories"])) {
                this.weightCategories = [] as any;
                for (let item of _data["weightCategories"])
                    this.weightCategories!.push(WeightCategoryInput.fromJS(item));
            }
            if (Array.isArray(_data["ageCategories"])) {
                this.ageCategories = [] as any;
                for (let item of _data["ageCategories"])
                    this.ageCategories!.push(AgeCategoryInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TournamentCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["registrationEndDate"] = this.registrationEndDate ? this.registrationEndDate.toISOString() : undefined as any;
        data["location"] = this.location;
        data["durationInMinutes"] = this.durationInMinutes;
        data["chiefJudgeName"] = this.chiefJudgeName;
        data["chiefSecretaryName"] = this.chiefSecretaryName;
        if (Array.isArray(this.weightCategories)) {
            data["weightCategories"] = [];
            for (let item of this.weightCategories)
                data["weightCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ageCategories)) {
            data["ageCategories"] = [];
            for (let item of this.ageCategories)
                data["ageCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITournamentCreateModel {
    name: string;
    startDate: Date;
    endDate: Date;
    registrationEndDate: Date;
    location: string;
    durationInMinutes: number;
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weightCategories?: WeightCategoryInput[] | undefined;
    ageCategories?: AgeCategoryInput[] | undefined;
}

export class TournamentOfficialsModel implements ITournamentOfficialsModel {
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weighInProtocolTitle?: string | undefined;
    competitionProtocolTitle?: string | undefined;

    constructor(data?: ITournamentOfficialsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chiefJudgeName = _data["chiefJudgeName"];
            this.chiefSecretaryName = _data["chiefSecretaryName"];
            this.weighInProtocolTitle = _data["weighInProtocolTitle"];
            this.competitionProtocolTitle = _data["competitionProtocolTitle"];
        }
    }

    static fromJS(data: any): TournamentOfficialsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentOfficialsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chiefJudgeName"] = this.chiefJudgeName;
        data["chiefSecretaryName"] = this.chiefSecretaryName;
        data["weighInProtocolTitle"] = this.weighInProtocolTitle;
        data["competitionProtocolTitle"] = this.competitionProtocolTitle;
        return data;
    }
}

export interface ITournamentOfficialsModel {
    chiefJudgeName?: string | undefined;
    chiefSecretaryName?: string | undefined;
    weighInProtocolTitle?: string | undefined;
    competitionProtocolTitle?: string | undefined;
}

export class TournamentNewsItem implements ITournamentNewsItem {
    id?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    location?: string | undefined;
    registrationEndDate?: Date | undefined;

    constructor(data?: ITournamentNewsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.location = _data["location"];
            this.registrationEndDate = _data["registrationEndDate"] ? new Date(_data["registrationEndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TournamentNewsItem {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentNewsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["location"] = this.location;
        data["registrationEndDate"] = this.registrationEndDate ? this.registrationEndDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ITournamentNewsItem {
    id?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    location?: string | undefined;
    registrationEndDate?: Date | undefined;
}

export class UserDto implements IUserDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;
    token?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["token"] = this.token;
        return data;
    }
}

export interface IUserDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;
    token?: string | undefined;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    readonly temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.temperatureC = _data["temperatureC"];
            (this as any).temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export class WeightCategory implements IWeightCategory {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    minWeight!: number;
    maxWeight!: number;
    tournaments?: WeightCategoryInTournament[] | undefined;

    constructor(data?: IWeightCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.minWeight = _data["minWeight"];
            this.maxWeight = _data["maxWeight"];
            if (Array.isArray(_data["tournaments"])) {
                this.tournaments = [] as any;
                for (let item of _data["tournaments"])
                    this.tournaments!.push(WeightCategoryInTournament.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeightCategory {
        data = typeof data === 'object' ? data : {};
        let result = new WeightCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["minWeight"] = this.minWeight;
        data["maxWeight"] = this.maxWeight;
        if (Array.isArray(this.tournaments)) {
            data["tournaments"] = [];
            for (let item of this.tournaments)
                data["tournaments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWeightCategory {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    minWeight: number;
    maxWeight: number;
    tournaments?: WeightCategoryInTournament[] | undefined;
}

export class WeightCategoryInTournament implements IWeightCategoryInTournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    sortOrder?: number;
    maxWeight?: number | undefined;
    isOpenEnded?: boolean;
    gender?: Gender | undefined;

    constructor(data?: IWeightCategoryInTournament) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.tournamentId = _data["tournamentId"];
            this.tournament = _data["tournament"] ? Tournament.fromJS(_data["tournament"]) : undefined as any;
            this.sortOrder = _data["sortOrder"];
            this.maxWeight = _data["maxWeight"];
            this.isOpenEnded = _data["isOpenEnded"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): WeightCategoryInTournament {
        data = typeof data === 'object' ? data : {};
        let result = new WeightCategoryInTournament();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["tournamentId"] = this.tournamentId;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : undefined as any;
        data["sortOrder"] = this.sortOrder;
        data["maxWeight"] = this.maxWeight;
        data["isOpenEnded"] = this.isOpenEnded;
        data["gender"] = this.gender;
        return data;
    }
}

export interface IWeightCategoryInTournament {
    id?: number;
    isDeleted?: boolean;
    createdOn?: Date;
    updatedOn?: Date;
    tournamentId?: number;
    tournament?: Tournament;
    sortOrder?: number;
    maxWeight?: number | undefined;
    isOpenEnded?: boolean;
    gender?: Gender | undefined;
}

export class WinnerModel implements IWinnerModel {
    participantId?: number;
    personName?: string | undefined;
    organization?: string | undefined;

    constructor(data?: IWinnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantId = _data["participantId"];
            this.personName = _data["personName"];
            this.organization = _data["organization"];
        }
    }

    static fromJS(data: any): WinnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new WinnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantId"] = this.participantId;
        data["personName"] = this.personName;
        data["organization"] = this.organization;
        return data;
    }
}

export interface IWinnerModel {
    participantId?: number;
    personName?: string | undefined;
    organization?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}